export default __webpack_public_path__ + "static/flag-es-74a4485828ac39897edbca113956ab40.svg";